// extracted by mini-css-extract-plugin
module.exports = {"text":"MessageWarning_text__3tx2B","contentButton":"MessageWarning_contentButton__3L1gC"};